import Subject from "../cse4sub/Subject";
import React from 'react'
//import csm from '../assets/CSE501mid21.pdf'
import cse from '../assets/CSE501end21.pdf'
export default function Py() {
  return (
    <div>
       <Subject title="(Python)IT Workshop(CSE501)"
    book1=" Starting Out with Python plus MyProgrammingLab with Pearson eText --Access Card Package (3rd 
      Edition) Tony Gaddis" 
    book2=" "
    book1Link="https://www.pdfdrive.com/download.pdf?id=105229559&h=d9dfba37ced6d1fdd7909b5cd13a99f2&u=cache&ext=pdf"
     book2Link="#" int21="#" mid21="#" end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}